<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">
          {{ createOrUpdate }}
        </h4>
      </div>
      <div class="level-right">
        <!-- <button
          v-if="purchaseOrder.purchaseOrderId"
          :class="buttonDownloadPoRequest"
          title="Download PDF"
          @click="
            downloadPdf(purchaseOrder.purchaseOrderId, purchaseOrder.poNum)
          "
        >
          <span class="icon">
            <i class="far fa-file-pdf"></i>
          </span>
        </button>
        &nbsp; -->
        <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
        &nbsp;
        <router-link
          :to="{
            name: 'List of Delivery',
            params: { page: 1, pageSize: 10 }
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Status (Automatic)</label>
          <div class="select is-small">
            <select v-model="delivery.deliveryStatus" disabled>
              <option value="0">QUEUE</option>
              <option value="1">IN TRANSIT</option>
              <option value="2">PARTIAL DELIVERED</option>
              <option value="3">DELIVERED</option>
              <option value="4">CANCELED</option>
              <option value="5">RETURN</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small"
            ><input
              type="radio"
              v-model="isSiOrDr"
              value="0"
              @change="siOrDrOnChange($event)"
              name="si"
            />
            S.I #
          </label>
          <div class="control">
            <input
              type="search"
              v-model="delivery.siNum"
              class="input is-small"
              :disabled="isDr"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">S.I Date</label>
          <div class="control">
            <input
              type="date"
              v-model="delivery.siDate"
              class="input is-small"
              :disabled="isDr"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small"
            ><input
              type="radio"
              v-model="isSiOrDr"
              value="1"
              @change="siOrDrOnChange($event)"
              name="dr"
            />D.R #</label
          >
          <div class="control">
            <input
              type="search"
              v-model="delivery.drNum"
              class="input is-small"
              :disabled="isSi"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">D.R Date</label>
          <div class="control">
            <input
              type="date"
              v-model="delivery.drDate"
              :disabled="isSi"
              class="input is-small"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Area or Delivery Address</label>
          <textarea
            style="height: 50px"
            type="text"
            class="input is-small"
            v-model="delivery.area"
            placeholder="Enter shipping address"
          />
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Delivery Date</label>
          <div class="control">
            <input
              type="date"
              v-model="delivery.deliveryDate"
              class="input is-small"
            />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label is-small">Client P.O #</label>
          <div class="control">
            <b-autocomplete
              id="searchClientPo"
              v-model="clientPoNum"
              size="is-small"
              :data="clientPoNums"
              placeholder="Search Client P.O #"
              @select="option => (selectedClientPoNum = option)"
              @input="searchClientPoNums"
              :loading="isFetchingClientPoNum"
            >
              <template slot="empty">
                <span v-if="isFetchingClientPoNum">Please wait...</span>
                <span v-if="clientPoNums.length === 0">No results found</span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <div class="field" v-if="receivedPoItems.length > 0">
      <label class="label is-small"
        >INCLUDE ALL
        <input
          type="checkbox"
          v-model="includeAllCheckbox"
          @click="includeAll($event)"
      /></label>
    </div>
    <b-table :data="receivedPoItems" :loading="isLoadingReceivePoItemTable">
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" label="INCLUDE?">
          <input type="checkbox" v-model="item.row.check" />
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="PRODUCT"
          >{{ item.row.product }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="QTY">{{
          item.row.qty
        }}</b-table-column>
        <b-table-column class="table-column-content-is-small" label="AMOUNT">{{
          item.row.amount | formatNumber
        }}</b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="RECEIVED DATE"
          >{{ item.row.receivedDate | formatDate }}</b-table-column
        >
      </template>
    </b-table>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <button
              id="addSubDetail"
              class="button is-small is-info"
              @click="addToDelivery()"
              :disabled="receivedPoItems.length < 1"
            >
              Add To Delivery
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-table :data="itemsToBeDelivered" :loading="isLoadingReceivePoItemTable">
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" label="PRODUCT">
          <span style="font-weight:bold">{{ item.row.product }}</span>
          <br />
          <span
            >({{ item.row.clientPo }} -
            <span style="font-style:italic">{{ item.row.client }}</span
            >)</span
          ></b-table-column
        >
        <b-table-column class="table-column-content-is-small" label="QTY">{{
          item.row.qty
        }}</b-table-column>
        <b-table-column class="table-column-content-is-small" label="AMOUNT">{{
          item.row.amount | formatNumber
        }}</b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="RECEIVED DATE"
          >{{ item.row.receivedDate | formatDate }}</b-table-column
        >
        <b-table-column class="table-column-content-is-small" label="NOTE">
          <textarea
            type="text"
            class="input is-small"
            v-model="item.row.note"
          />
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="STATUS">
          <div class="select is-small">
            <select v-model="item.row.deliveryStatus">
              <option value="0">QUEUE</option>
              <option value="1">IN TRANSIT</option>
              <option value="2">PARTIAL DELIVERED</option>
              <option value="3">DELIVERED</option>
              <option value="4">CANCELED</option>
              <option value="5">RETURN</option>
            </select>
          </div>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            class="button is-danger is-small"
            @click="remove(item.row.poRequestDetailId)"
          >
            Remove
          </button>
        </b-table-column>
      </template>
    </b-table>
    <!-- <div class="notification">
      <loading
        :active.sync="isLoadingTotal"
        color="#3BAFDA"
        :can-cancel="false"
        :is-full-page="isFullPage"
      ></loading>
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="field">
            <div class="control">
              <label class="label is-small">Total</label>
              <div class="control">
                <h4 class="title is-4">{{ this.poTotal.total }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <br />
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
        <!-- &nbsp;
        <button :class="buttonSave" @click="saveAndSend(true)">
          Save & send
                </button>-->
        &nbsp;
        <router-link
          :to="{
            name: 'List of Delivery',
            params: { page: 1, pageSize: 10 }
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import axios from "axios";
import moment from "moment";
import numeral from "numeral";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import _ from "lodash";
import CreateProductOrService from "./../ProductOrService/CreateEdit";

Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter("formatDate", function(value) {
  return moment(value).format("MM/DD/YYYY"); // displaying other groupings/separators is possible, look at the docs
});

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  components: {
    Loading,
    CreateProductOrService
  },
  computed: {
    ...mapState("productorservice", {
      productOrServiceState: state => state.productOrServiceState
    })
  },
  data: () => ({
    isFetchingSavedInfo: false,
    poTotal: {
      subTotal: 0,
      total: 0
    },
    isSiOrDr: 0,
    isSi: true,
    isDr: false,
    itemsToBeDelivered: [],
    receivedPoItems: [],
    isLoadingReceivePoItemTable: false,
    poNumber: "",
    createOrUpdate: "Create ",
    addOrEditToTable: "Add",
    includeAllCheckbox: false,
    purchaseOrder: {
      purchaseOrderId: 0,
      poNum: 0,
      supplierId: 0,
      emails: "",
      cc: "",
      bcc: "",
      poStatus: 0,
      mailingAddress: "",
      shipTo: "",
      shippingAddress: "",
      shipVia: "",
      poDate: null,
      cvNo: "",
      checkNo: "",
      oldPoNum: "",
      messageToSupplier: "",
      purchaseOrderDetails: []
    },
    delivery: {
      deliveryId: 0,
      deliveryDate: null,
      area: "",
      siNum: "",
      drNum: "",
      siDate: moment(new Date()).format("YYYY-MM-DD"),
      drDate: moment(new Date()).format("YYYY-MM-DD"),
      deliveryDetails: []
    },
    // search client po #
    clientPoNum: "",
    clientPoNums: [],
    selectedClientPoNum: 0,
    selectedClientPoNumForEdit: {},
    isFetchingClientPoNum: false,
    // loadings
    isLoadingTable: false,
    isLoadingTotal: false,
    isFullPage: false,
    // buttons
    buttonDelete: appButton.isLoadingDanger(false),
    buttonSave: appButton.isLoadingSuccess(false),
    buttonSaveAndSend: appButton.isLoadingSuccess(false),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false)
  }),
  created() {
    const deliveryId = this.$route.params.deliveryId;
    if (deliveryId) {
      this.getDeliveryById(deliveryId);
    } else {
      // CREATE Mode
      this.getCurrentDateFromServer();
    }
  },
  methods: {
    ...mapActions("productorservice", [
      "openCreateEditModal",
      "clearSelectedPurchaseOrderState"
    ]),
    siOrDrOnChange(e) {
      if (e.srcElement.name === "si") {
        this.delivery.drNum = "";
        this.delivery.drDate = moment(new Date()).format("YYYY-MM-DD");
        this.isSi = true;
        this.isDr = false;
      } else {
        this.delivery.siNum = "";
        this.delivery.siDate = moment(new Date()).format("YYYY-MM-DD");
        this.isSi = false;
        this.isDr = true;
      }
    },
    addToDelivery() {
      const queueItems = this.receivedPoItems.filter(x => x.check === true);
      const existingItems = this.itemsToBeDelivered;
      queueItems.forEach(d => {
        if (existingItems.length === 0) {
          this.itemsToBeDelivered = [d, ...this.itemsToBeDelivered];
        } else {
          const item = existingItems.find(
            x => x.poRequestDetailId === d.poRequestDetailId
          );
          if (!item) {
            this.itemsToBeDelivered = [d, ...this.itemsToBeDelivered];
          }
        }
        // insert optional text area here
        this.itemsToBeDelivered = this.itemsToBeDelivered.map(x => ({
          ...x,
          note: x.note,
          deliveryStatus: !x.deliveryStatus ? 0 : x.deliveryStatus
        }));
      });
    },
    includeAll(e) {
      this.receivedPoItems = this.receivedPoItems.map(x => ({
        ...x,
        check: e.target.checked
      }));
    },
    goBack() {
      this.$router.go(-1);
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then(response => {
          this.delivery.deliveryDate = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    getDeliveryById(id) {
      this.isFetchingSavedInfo = true;
      this.createOrUpdate = "Edit";
      axios
        .get(`api/deliveries/${id}`)
        .then(response => {
          this.delivery = response.data;
          this.delivery.deliveryDate = moment(
            this.delivery.deliveryDate
          ).format("YYYY-MM-DD");
          if (this.delivery.siNum) {
            this.isSiOrDr = 0;
            this.isSi = true;
            this.isDr = false;
            this.delivery.siDate = moment(this.delivery.siDate).format(
              "YYYY-MM-DD"
            );
          } else {
            this.isSiOrDr = 1;
            this.isDr = true;
            this.isSi = false;
            this.delivery.drDate = moment(this.delivery.drDate).format(
              "YYYY-MM-DD"
            );
          }
          this.itemsToBeDelivered = this.delivery.deliveryDetails;
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    remove(id) {
      if (this.itemsToBeDelivered.length > 0) {
        const yesOrNo = confirm(
          "Are you sure do you want to remove this data?"
        );
        if (yesOrNo) {
          this.itemsToBeDelivered = this.itemsToBeDelivered.filter(
            d => d.poRequestDetailId !== id
          );
        }
      }
    },
    downloadPdf(id, poNumber) {
      if (id) {
        this.buttonDownloadPoRequest = appButton.isLoadingDefault(true);
        axios
          .get(`downloadables/purchaseorder?id=${id}`, {
            responseType: "blob"
          })
          .then(response => {
            console.log(response.data);
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `PURCHASE ORDER ${poNumber}.pdf`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadPoRequest = appButton.isLoadingDefault(false))
          );
      }
    },
    saveAndSend(isSend) {
      if (this.isSi) {
        if (!this.delivery.siNum) {
          appToast.danger("S.I # is empty.");
          return false;
        }
      } else {
        if (!this.delivery.drNum) {
          appToast.danger("D.R # is empty.");
          return false;
        }
      }

      if (this.itemsToBeDelivered.length < 1) {
        appToast.danger(
          "Table for item delivery is empty. Please select P.O # then click 'Add to Delivery'."
        );
        return false;
      }

      if (this.isSi) {
        this.delivery.drNum = null;
        this.delivery.drDate = null;
        if (!this.delivery.siDate) {
          appToast.danger("S.I Date is empty.");
          return false;
        }
      } else {
        this.delivery.siNum = null;
        this.delivery.siDate = null;
        if (!this.delivery.drDate) {
          appToast.danger("D.R Date is empty.");
          return false;
        }
      }

      this.buttonSave = appButton.isLoadingSuccess(true);
      // CREATE
      this.delivery.deliveryDetails = this.itemsToBeDelivered;
      const deliveryId = this.delivery.deliveryId;
      if (!deliveryId) {
        axios
          .post(`api/deliveries/`, this.delivery)
          .then(response => {
            appToast.success(response.data.message);
            this.$router.push({
              name: "List of Delivery",
              params: { page: 1, pageSize: 10 }
            });
          })
          .catch(error => {
            console.log(error);
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      } else {
        axios
          .put(`api/deliveries/${deliveryId}`, this.delivery)
          .then(response => {
            appToast.success(response.data.message);
            this.$router.push({
              name: "List of Delivery",
              params: { page: 1, pageSize: 10 }
            });
          })
          .catch(error => {
            console.log(error);
            appToast.danger(error.response.data);
            this.getDeliveryById(deliveryId);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    },
    searchClientPoNums() {
      // authService.isLoggedIn() // check login
      axios
        .get(`api/searchqueries/po-request-client-po/${this.clientPoNum}`)
        .then(response => {
          this.clientPoNums = response.data;
        })
        .catch(error => console.log(error));
    },
    checkIfValIsValidNumber(number) {
      return !number ? 0 : number;
    }
  },
  watch: {
    selectedClientPoNum() {
      const poRequestId = this.selectedClientPoNum.id;
      if (poRequestId) {
        this.includeAllCheckbox = false;
        this.isLoadingReceivePoItemTable = true;
        this.delivery.area = this.selectedClientPoNum.description1;
        axios
          .get(`api/deliveries/received-items-by-po-request-id/${poRequestId}`)
          .then(response => {
            console.log(response);
            const dataWithCheck = response.data.receiveItems.map(x => ({
              ...x,
              check: false
            }));
            this.receivedPoItems = dataWithCheck;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.isLoadingReceivePoItemTable = false;
          });
      } else {
        this.selectedSupplier = 0;
      }
    }
  }
};
</script>
